import Model from "../../../Model.js";

/**
 * `Item` represents a todo item and is a part of a period report's
 * `Checklist`. The receiver is meant to be instantiated for each
 * period report.
 *
 * @param {string} id - A guid used to uniquely identify the item
 * within its checklist.
 * @param {string} label - A humane-readable short title summarizing
 * what the todo is about.
 * @param {string} description - A humane-readable description of what
 * the accountant is expected to verify.
 * @param {string} [comment] - An optional text that the accountant
 * can quickly add to the period report.
 * @param {booleam} [checked] - An optional value to indicate if the
 * item is completed.
 */
export default class ChecklistItem extends Model {
	constructor({
		id = "",
		label = "",
		description = "",
		comment = null,
		checked = false,
	} = {}) {
		super(...arguments);

		this._id = id;
		this._label = label;
		this._description = description;
		this._comment = comment;
		this._checked = checked;
	}

	getId() {
		return this._id;
	}

	getLabel() {
		return this._label;
	}

	getDescription() {
		return this._description;
	}

	getComment() {
		return this._comment;
	}

	hasComment() {
		return this._comment && this._comment.length;
	}

	isChecked() {
		return this._checked;
	}

	setChecked(isChecked) {
		this._checked = isChecked;
	}

	hasDescription() {
		return this._description && this._description.length;
	}

	toggle() {
		this.setChecked(!this._checked);
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);

		data.checked = data.isChecked;
	}
}
